module.exports = __webpack_public_path__ + "a5ea1a77258ea208b91f9b2f0ed2464c.png";